import { useEffect, useState } from "react";
import { TrendingUp, ShieldAlert } from "lucide-react";
import { Card } from "@/components/common/PageHeader";
import { Loading, Stat } from "@/pages/_shared";
import api from "@/lib/api";

export default function CreditBuilderAdmin() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/credit-builder/programs/admin/overview").then(({ data }) => setData(data)); }, []);
  if (!data) return <Loading />;
  const { stats, by_type, members, note } = data;

  return (
    <div className="animate-fade-up space-y-6" data-testid="credit-builder-admin-page">
      <div>
        <div className="flex flex-wrap items-center gap-2">
          <h1 className="flex items-center gap-2 font-head text-2xl font-extrabold tracking-tight text-slate-900"><TrendingUp size={22} className="text-[#b0862f]" /> Credit Builder (Community)</h1>
          <span className="rounded-full bg-amber-100 px-2 py-0.5 font-mono text-[10px] font-bold uppercase tracking-wider text-amber-700">BETA</span>
        </div>
        <p className="mt-1 text-[13px] text-slate-500">Oversight of the alternative-data credit-building programs your community is enrolled in.</p>
      </div>

      <div className="flex items-start gap-2 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-[12px] text-amber-800">
        <ShieldAlert size={16} className="mt-0.5 shrink-0" /> <span>{note} Reporting status: <b>{stats.reporting_connected ? "Connected" : "Not connected"}</b>.</span>
      </div>

      <div className="grid gap-3 sm:grid-cols-4">
        <Stat label="Members enrolled" value={stats.members_enrolled} tone="blue" />
        <Stat label="Total programs" value={stats.total_programs} tone="slate" />
        <Stat label="On-time payments" value={stats.on_time_payments} tone="green" />
        <Card className="p-4"><div className="font-mono text-[10px] uppercase tracking-wider text-slate-400">Bureau reporting</div><div className={`mt-1 font-head text-[15px] font-bold ${stats.reporting_connected ? "text-emerald-600" : "text-amber-600"}`}>{stats.reporting_connected ? "Connected" : "Not connected"}</div></Card>
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <Card className="p-5" data-testid="cb-admin-bytype">
          <div className="mb-3 font-head text-[14px] font-bold text-slate-900">Enrollment by program</div>
          {by_type.length === 0 ? <div className="py-6 text-center text-[13px] text-slate-400">No enrollments yet.</div> : (
            <div className="space-y-1.5">{by_type.map((t) => (<div key={t.type} className="flex items-center justify-between text-[13px]"><span className="text-slate-700">{t.label}</span><span className="font-mono text-slate-500">{t.count}</span></div>))}</div>
          )}
        </Card>
        <Card className="p-5" data-testid="cb-admin-members">
          <div className="mb-3 font-head text-[14px] font-bold text-slate-900">Members</div>
          {members.length === 0 ? <div className="py-6 text-center text-[13px] text-slate-400">No members enrolled yet.</div> : (
            <div className="space-y-2">{members.map((m) => (
              <div key={m.customer_id} className="flex items-center justify-between gap-3 border-b border-slate-50 py-2 text-[13px] last:border-0">
                <div className="min-w-0"><div className="truncate font-semibold text-slate-800">{m.company}</div><div className="font-mono text-[10px] text-slate-400">{m.programs.join(" · ")}</div></div>
                <span className="shrink-0 font-mono text-[11px] text-emerald-600">{m.on_time} on-time</span>
              </div>
            ))}</div>
          )}
        </Card>
      </div>
    </div>
  );
}
